import React from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import { BsTrash, BsFillPencilFill } from "react-icons/bs";
import { PAGE_TYPE } from "~/configs/constants";
import { getGridLineColor } from '../../helpers/utils'
import { GrView } from "react-icons/gr";
import { BiCloudDownload } from "react-icons/bi";
import { IoDuplicate } from "react-icons/io5";

const PageCard = ({
  id,
  description,
  type,
  tagsCount,
  imagesCount,
  index,
  onClick,
  onDelete,
  onView,
  onDownload,
  onDuplicate
}) => (
  <Card style={{ cursor: "pointer", marginBottom: "0px" }} className="card-chart">
    <CardBody style={{padding: "8px", paddingLeft: "5px", backgroundColor: (index % 2 === 0 ? "inherit" : getGridLineColor())}}>
      <Row>
        <Col xs={2} md={1} style={{display: "flex", alignItems: "center"}}>          
          {id}
        </Col>
        <Col xs={6} md={4} style={{display: "flex", alignItems: "center"}}>
          {description}
        </Col>
        <Col md={3} style={{display: "flex", alignItems: "center"}} className="display-none-xs">
          {(type === PAGE_TYPE.tags ? "Etiquetas": "")}
          {(type === PAGE_TYPE.list ? "Lista": "")}
          {(type === PAGE_TYPE.table ? "Tabela": "")}
          {(type === PAGE_TYPE.midia ? "Mídia": "")}
          {(type === PAGE_TYPE.folder ? "Cartaz": "")}
          {(type === PAGE_TYPE.info ? "Info": "")}
        </Col>
        <Col md={2} style={{display: "flex", alignItems: "center"}} className="display-none-xs">
          {(type === PAGE_TYPE.midia || type === PAGE_TYPE.folder || type === PAGE_TYPE.info  ? imagesCount : tagsCount)}
        </Col>
        <Col xs={4} md={2} style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
          <IoDuplicate
            onClick={onDuplicate}
            className="icon-xs"
            style={{marginLeft: "5px", marginRight: "5px"}}
            title="Duplicar página"
            size= {20}
          /> 
          {type !== PAGE_TYPE.midia 
          && type !== PAGE_TYPE.info 
          && (((type === PAGE_TYPE.midia || type === PAGE_TYPE.folder || type === PAGE_TYPE.info) && imagesCount > 0) || ((type === PAGE_TYPE.tags || type === PAGE_TYPE.list || type === PAGE_TYPE.table) && tagsCount > 0)) 
          && (
          <BiCloudDownload 
            onClick={onDownload}
            className="icon-xs"
            style={{marginLeft: "5px", marginRight: "5px"}}
            title="Baixar"
            size= {20}
          />
          )}
          {type !== PAGE_TYPE.midia 
          && type !== PAGE_TYPE.info 
          && (((type === PAGE_TYPE.midia || type === PAGE_TYPE.folder || type === PAGE_TYPE.info) && imagesCount > 0) || ((type === PAGE_TYPE.tags || type === PAGE_TYPE.list || type === PAGE_TYPE.table) && tagsCount > 0)) 
          && (
          <GrView
            onClick={onView}
            className="icon-xs"
            style={{marginLeft: "5px", marginRight: "5px"}}
            title="Visualizar"
            size= {20}
          />
          )}
          <BsTrash
            onClick={onDelete}
            className="icon-xs"
            style={{marginLeft: "5px", marginRight: "5px"}}
            title="Deletar"
            size= {20}
            color="#ec250d"
          /> 
          <BsFillPencilFill              
              size= {20}
              className="icon-xs"
              style={{marginLeft: "5px", marginRight: "5px"}}
              title="Editar"
              onClick={onClick}
              color="#4cd678"
          />
        </Col>      
      </Row>
    </CardBody>
  </Card>
);

export default PageCard;
